import { render, staticRenderFns } from "./IndagineEpidemiologicaTetanoEditComponent.vue?vue&type=template&id=5d127a3c"
import script from "./IndagineEpidemiologicaTetanoEditComponent.vue?vue&type=script&lang=js"
export * from "./IndagineEpidemiologicaTetanoEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports